import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidenavModule, WavesModule, AccordionModule } from 'ng-uikit-pro-standard';
import { NavbarPreviewComponent } from './navbar-preview/navbar-preview.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NavbarbackComponent } from './navbarback/navbarback.component';



@NgModule({
  declarations: [
    NavbarComponent,
    SidebarComponent,
    NavbarPreviewComponent,
    NavbarbackComponent
  ],
  exports: [
    NavbarComponent,
    SidebarComponent,
    NavbarPreviewComponent,
    NavbarbackComponent
  ],
  imports: [
    CommonModule,
    SidenavModule,
    WavesModule,
    AccordionModule,
    MDBBootstrapModulesPro.forRoot(),
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class SharedModule { }
